import { useMemo } from "react";
import { ApolloClient, InMemoryCache, ApolloProvider, createHttpLink } from "@apollo/client";
import { useAtomValue } from "jotai";
import { contentfulKeyAtom } from "../../state/appState";

export const ApolloWrapper = ({ children }) => {
	const token = useAtomValue(contentfulKeyAtom);

	const client = useMemo(() => {
		const httpLink = createHttpLink({
			uri: `https://graphql.contentful.com/content/v1/spaces/${process.env.REACT_APP_CONTENTFUL_SPACE}`,
			headers: {
				authorization: token ? `Bearer ${token}` : "",
			},
		});

		return new ApolloClient({
			link: httpLink,
			cache: new InMemoryCache(),
		});
	}, [token]); // Client recreates only when token changes

	return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
